import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import UIValue from './uiValue';
import UIValidation from './uiValidation';
const { RangePicker } = DatePicker;
function UIRangeComponent(props) {
    const [value, setValue] = useState(props.value || []);
    useEffect(() => {
        if (!props.value || !props.value[0] || !props.value[1])
            return;
        setValue(props.value);
    }, [props.value]);
    const handleChange = (_, dateStrings) => {
        setValue(dateStrings);
        props.onChange(dateStrings);
    };
    return (_jsxs("div", { style: { display: 'flex', marginBottom: '16px' }, children: [_jsx("label", { style: { marginRight: '16px', whiteSpace: 'nowrap', width: '140px', textAlign: 'left' }, children: props.title }), _jsx(RangePicker, { style: { flex: 1 }, onChange: handleChange, value: !value[0] ? undefined : [dayjs(value[0]), dayjs(value[1])], disabledDate: props.disabledDateRange ?? undefined })] }));
}
export default class UIRange extends UIValue {
    title;
    disabledDateRange;
    onChange = (_) => { };
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        this.value = ['', ''];
    }
    getComponent() {
        const handleRangeChange = (dateString) => {
            this.value = dateString;
            this?.onChange(dateString);
            this.error = undefined;
        };
        const props = {
            title: this.title,
            onChange: handleRangeChange,
            value: this.value,
            disabledDateRange: this.disabledDateRange,
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(UIRangeComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiRange.js.map